/**
 * Shared map polygon / circle and shipment stop card styling by role (origin, waypoints, destination).
 * Map `fill` / `stroke` align with Tailwind badge colors (green-500, blue-500, slate-700).
 */

export type ShipmentStopRole = 'origin' | 'waypoint' | 'destination'

export type ShipmentStopMapStyle = {
  fill: string
  fillOpacity: number
  stroke: string
  strokeOpacity: number
  strokeWidth: number
}

export type ShipmentStopRoleVisual = {
  map: ShipmentStopMapStyle
  /** Tailwind classes for the numbered circle (1, 2, …) on the stop card */
  cardNumberCircleClass: string
  /** Tailwind classes for the origin / waypoint / destination label pill */
  cardRoleBadgeClass: string
}

export const SHIPMENT_STOP_ROLE_VISUAL: Record<ShipmentStopRole, ShipmentStopRoleVisual> = {
  origin: {
    map: {
      fill: '#22c55e',
      fillOpacity: 0.22,
      stroke: '#16a34a',
      strokeOpacity: 0.95,
      strokeWidth: 2,
    },
    cardNumberCircleClass: 'bg-green-500',
    cardRoleBadgeClass: 'bg-green-100 text-green-700',
  },
  waypoint: {
    map: {
      fill: '#3b82f6',
      fillOpacity: 0.2,
      stroke: '#2563eb',
      strokeOpacity: 0.95,
      strokeWidth: 2,
    },
    cardNumberCircleClass: 'bg-blue-500',
    cardRoleBadgeClass: 'bg-blue-100 text-blue-700',
  },
  destination: {
    map: {
      fill: '#475569',
      fillOpacity: 0.2,
      stroke: '#334155',
      strokeOpacity: 0.95,
      strokeWidth: 2,
    },
    cardNumberCircleClass: 'bg-slate-700',
    cardRoleBadgeClass: 'bg-slate-100 text-slate-700',
  },
}

export function shipmentStopRoleFromIndex(index: number, totalStops: number): ShipmentStopRole {
  if (index === 0) return 'origin'
  if (index === totalStops - 1) return 'destination'
  return 'waypoint'
}
